import { useEffect } from 'react'
import { useViewPageLayoutChrome } from 'pages/settings/pages/billing/layout/ViewPageLayout/context/viewPageLayoutChromeContext'

export const useUpgradeLayoutBackChrome = (onBack: () => void) => {
  const { setChrome } = useViewPageLayoutChrome()

  useEffect(() => {
    setChrome({ showBack: true, onBack })

    return () => {
      setChrome({})
    }
  }, [onBack, setChrome])
}
